import { baseTheme } from "@app/theme";
import { Box, ThemeProvider, Typography } from "@mui/material";
import dolphinIcon from "@assets/dolphin-icon.png";
import "./styles.css";

export const MsalLoadingScreen = () => {
  return (
    <ThemeProvider theme={baseTheme}>
      <Box
        sx={{
          height: "99vh",
          overflowX: "auto",
          borderRadius: "0px",
          backgroundColor: "primary.light",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          paddingTop: "75px",
          gap: "45px",
        }}
      >
        <Typography
          variant="h2"
          sx={{
            color: "secondary.contrastText",
          }}
        >
          Just a moment!
        </Typography>
        <div className="msal_loading_container">
          <img src={dolphinIcon} />
        </div>
        <Typography
          sx={{
            color: "secondary.contrastText",
          }}
        >
          Dolphin is making sure you're not a bad guy...
        </Typography>
      </Box>
    </ThemeProvider>
  );
};

export default MsalLoadingScreen;
